export const RETAIL_PLAYER_PATH_SUBSTR = '/music/player';
export const RETAIL_PLAYER_PATH_SUBSTR_REGEX_EXP = /^\/*.*\/music\/player\/?/;
export const RETAIL_PLAYER_DP_ASIN_REGEX_PATH = /(^|^\/-\/[a-z]{2})\/([^\/]+\/dp|d|dp|gp\/product|gp\/aw\/d|gp\/mobile\/udp)\/([A-Z0-9]{10})/;
export const RETAIL_PLAYER_DP_ASIN_REGEX_REPLACE = /(^|^\/-\/[a-z]{2})\/([^\/]+\/dp|d|dp|gp\/product|gp\/aw\/d|gp\/mobile\/udp)\//;
export const RETAIL_WEB_PLAYER_Z_INDEX = 209;
export const AMAZON_MUSIC_DESKTOP_IMAGE_LOGO = 'https://m.media-amazon.com/images/G/01/music-retailwebplayer/rwp_mai_qr_code_amazon_music_round_logo.png';
